import { KbWebSourcePageDto, KbWebSourcePageStatus } from "types/knowledgeBase";

export type WebSourcePageStatusFilter = "all" | KbWebSourcePageStatus;

/**
 * Narrows the page list by free-text search (URL or title) and status.
 *
 * Kept out of the component so the matching rules can be tested directly — the list is
 * how an admin finds a specific page among hundreds, so a silent mismatch here reads as
 * "that page was never crawled".
 */
export function filterWebSourcePages(
  pages: KbWebSourcePageDto[],
  search: string,
  statusFilter: WebSourcePageStatusFilter,
): KbWebSourcePageDto[] {
  const term = search.trim().toLowerCase();

  return pages.filter((page) => {
    if (statusFilter !== "all" && page.status !== statusFilter) {
      return false;
    }

    if (!term) {
      return true;
    }

    return (
      page.url.toLowerCase().includes(term) ||
      (page.displayUrl ?? "").toLowerCase().includes(term) ||
      (page.title ?? "").toLowerCase().includes(term)
    );
  });
}

/** Human-readable stored size. Returns an em dash when the size is unknown. */
export function formatContentLength(contentLength?: number): string {
  if (contentLength === undefined || contentLength === null) {
    return "—";
  }

  return contentLength >= 1000
    ? `${Math.round(contentLength / 1000)} kB`
    : `${contentLength} B`;
}
